'use strict';

/*
 * Selects the text in an input field on click
 */

angular.module('v6CoreModule').directive('onClickSelect', ($rootScope) => ({
  restrict: 'A',

  link: function (scope, elm, attrs) {
    function selectText() {
      let text = '';

      $(elm).select();
      const attr = elm.attr('ng-model');
      if (window.getSelection) {
        text = window.getSelection().toString();
        // @ts-ignore
      } else if (document.selection && document.selection.type != 'Control') {
        // @ts-ignore
        text = document.selection.createRange().text;
      }

      // @ts-ignore
      $rootScope?.textProperties[attr] = text;
    }

    elm.bind('click', selectText);

    elm.bind('focus', () => {
      // @ts-ignore
      scope.$parent.currentFocus = attrs.ngModel;
      selectText();
    });
  },
}));
